import { render } from "./BaseLayout.vue?vue&type=template&id=2df72c94&scoped=true"
const script = {}

import "./BaseLayout.vue?vue&type=style&index=0&id=2df72c94&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df72c94"]])

export default __exports__